import React from 'react';
import { Box } from '@mui/material';

const CoreCityGroupLogo = ({ size = 48, color = '#667eea', showText = true }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background circle */}
        <circle cx="24" cy="24" r="24" fill="url(#gradient)" />
        
        {/* Building icon */}
        <path
          d="M14 32V20L24 12L34 20V32H14Z"
          fill="white"
          fillOpacity="0.9"
        />
        
        {/* Windows */}
        <rect x="18" y="22" width="3" height="3" fill="white" fillOpacity="0.7" />
        <rect x="23" y="22" width="3" height="3" fill="white" fillOpacity="0.7" />
        <rect x="28" y="22" width="3" height="3" fill="white" fillOpacity="0.7" />
        <rect x="18" y="27" width="3" height="3" fill="white" fillOpacity="0.7" />
        <rect x="23" y="27" width="3" height="3" fill="white" fillOpacity="0.7" />
        <rect x="28" y="27" width="3" height="3" fill="white" fillOpacity="0.7" />
        
        {/* Door */}
        <rect x="22" y="30" width="4" height="2" fill="white" fillOpacity="0.8" />
        
        {/* Gradient definition */}
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#667eea" />
            <stop offset="100%" stopColor="#764ba2" />
          </linearGradient>
        </defs>
      </svg>
      
      {showText && (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box
            sx={{
              fontSize: size * 0.4,
              fontWeight: 700,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              lineHeight: 1,
            }}
          >
            Core City
          </Box>
          <Box
            sx={{
              fontSize: size * 0.25,
              fontWeight: 600,
              color: 'text.secondary',
              lineHeight: 1,
            }}
          >
            Group
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default CoreCityGroupLogo; 